import { AnyAction } from 'redux';
import { DocumentType } from '@synergy/models';

import { TRANSITION_ACTIVITIES_RECEIVED, TRANSITION_ACTIVITIES_RESET } from '../actions/transitions-activity-actions';
import { TransitionActivity } from '../models/transition-activity';

export interface TransitionActivitiesReducerState {
    flat: TransitionActivity[] | null;
    sourceDocumentType: DocumentType | null;
    sourceDocumentId: number;
    transitionsFromCount: number;
}

const initialTransitionsReducerState: TransitionActivitiesReducerState = {
    flat: null,
    sourceDocumentType: null,
    sourceDocumentId: 0,
    transitionsFromCount: 0,
};

export const transitionActivitiesReducer = (
    state: TransitionActivitiesReducerState = initialTransitionsReducerState,
    action: AnyAction
): TransitionActivitiesReducerState => {
    const { type } = action;
    switch (type) {
        case TRANSITION_ACTIVITIES_RECEIVED: {
            const transitionActivities: TransitionActivity[] = action['transitionActivities'];
            const transitionsFromCount: number = action['transitionsFromCount'];
            const sourceDocumentType: DocumentType = action['sourceDocumentType'];
            const sourceDocumentId: number = action['sourceDocumentId'];

            return {
                ...state,
                flat: transitionActivities,
                sourceDocumentType,
                sourceDocumentId,
                transitionsFromCount,
            };
        }

        case TRANSITION_ACTIVITIES_RESET: {
            return {
                ...initialTransitionsReducerState,
            };
        }

        default: {
            return state;
        }
    }
};
